import { ref } from 'vue'

export function useSectionsStore(api) {
  const sections = ref([])
  const loading = ref(false)

  async function fetchSections() {
    loading.value = true
    try {
      const data = await api.get('/api/sections')
      sections.value = data.sections
    } finally {
      loading.value = false
    }
  }

  async function createSection(attrs) {
    const data = await api.post('/api/sections', { section: attrs })
    sections.value.push(data.section)
    return data.section
  }

  async function updateSection(id, attrs) {
    const data = await api.patch(`/api/sections/${id}`, { section: attrs })
    const idx = sections.value.findIndex(s => s.id === id)
    if (idx !== -1) sections.value[idx] = data.section
    return data.section
  }

  async function deleteSection(id) {
    await api.delete(`/api/sections/${id}`)
    sections.value = sections.value.filter(s => s.id !== id)
  }

  async function batchUpdateSections(updates) {
    const data = await api.post('/api/sections/batch_update', { sections: updates })
    sections.value = data.sections
  }

  function toggleCollapse(id) {
    const section = sections.value.find(s => s.id === id)
    if (!section) return
    // Optimistic, single render: don't replace the object with the server echo.
    section.is_collapsed = !section.is_collapsed
    api.patch(`/api/sections/${id}`, { section: { is_collapsed: section.is_collapsed } })
       .catch(() => {})
  }

  return {
    sections,
    loading,
    fetchSections,
    createSection,
    updateSection,
    deleteSection,
    batchUpdateSections,
    toggleCollapse,
  }
}
